export const PUBLISHING_BLOCKED_MESSAGE =
  "La validation de vos informations fiscales est nécessaire avant de pouvoir publier des paniers."

export const canStorePublishBags = store => store?.canPublishBags === true

export const getFiscalBannerVariant = store => {
  if (!store || (store.fiscalStatus === "approved" && canStorePublishBags(store))) {
    return null
  }

  if (store.fiscalStatus === "rejected") return "rejected"
  if (store.fiscalStatus === "pending_review") return "pending_review"
  if (store.fiscalInformationComplete === false || !canStorePublishBags(store)) {
    return "missing_information"
  }

  return null
}

